/* eslint-disable complexity */
import { ErinnerungsZeiten } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erinnerungsZeiten';
import dayjs from 'dayjs';

export function getErinnerungsZeitFromFristDatum(
  erinnerungsZeitValue: string,
  fristDatum: string,
): string {
  if (erinnerungsZeitValue === ErinnerungsZeiten.AM_GLEICHEN_TAG) {
    return dayjs(fristDatum).format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.EIN_TAG_ZUVOR) {
    return dayjs(fristDatum).subtract(1, 'day').format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.EINE_WOCHE_ZUVOR) {
    return dayjs(fristDatum).subtract(1, 'week').format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.ZWEI_WOCHEN_ZUVOR) {
    return dayjs(fristDatum).subtract(2, 'week').format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.VIER_WOCHEN_ZUVOR) {
    return dayjs(fristDatum).subtract(4, 'week').format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.SECHS_WOCHEN_ZUVOR) {
    return dayjs(fristDatum).subtract(6, 'week').format('YYYY-MM-DD');
  } else if (erinnerungsZeitValue === ErinnerungsZeiten.DREI_MONATE_ZUVOR) {
    return dayjs(fristDatum).subtract(3, 'month').format('YYYY-MM-DD');
  } else {
    throw new Error('erinnerungsZeitValue not implemented');
  }
}

export function getErinnerungsZeitFromFristDatumAndErinnerungsDatum(
  erinnerungAm: string,
  fristDatum: string,
): ErinnerungsZeiten {
  const erinnerungAmDate = dayjs(erinnerungAm);
  const fristDatumDate = dayjs(fristDatum);

  if (erinnerungAmDate.isSame(fristDatumDate, 'day')) {
    return ErinnerungsZeiten.AM_GLEICHEN_TAG;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(1, 'day'), 'day')
  ) {
    return ErinnerungsZeiten.EIN_TAG_ZUVOR;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(1, 'week'), 'day')
  ) {
    return ErinnerungsZeiten.EINE_WOCHE_ZUVOR;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(2, 'week'), 'day')
  ) {
    return ErinnerungsZeiten.ZWEI_WOCHEN_ZUVOR;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(4, 'week'), 'day')
  ) {
    return ErinnerungsZeiten.VIER_WOCHEN_ZUVOR;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(6, 'week'), 'day')
  ) {
    return ErinnerungsZeiten.SECHS_WOCHEN_ZUVOR;
  } else if (
    erinnerungAmDate.isSame(fristDatumDate.subtract(3, 'month'), 'day')
  ) {
    return ErinnerungsZeiten.DREI_MONATE_ZUVOR;
  } else {
    throw new Error('erinnerungAm value not implemented');
  }
}
